import { BASE_PREFIX } from "@/config";

/**
 * 문서 뷰어(PDF)를 새 창으로 연다. (History 상세 화면에서 사용)
 * History 백엔드의 /api/pdfviewer 로 열며, 같은 오리진이라 mixed content/CORS 없음.
 *  - dev : /api/history/pdfviewer?docType=...      (vue 프록시 → History)
 *  - prod: /rmt/api/history/pdfviewer?docType=...   (BASE_PREFIX=/rmt, Nginx → History)
 * @param {*} pValue
 * @param {*} pDocType
 */
export function OpenViewer(pValue, pDocType) {
  const url =
    BASE_PREFIX + "/api/history/pdfviewer?docType=" + encodeURIComponent(pDocType);
  window.open(
    url,
    "popViewer",
    "top=10, left=10, width=1000, height=1100, status=no, menubar=no, toolbar=no, resizable=no"
  );
}

/**
 * Get Current time
 * format : YYYY. MM. DD. 오후 HH:MM:SS
 * @returns
 */
export function GetCurrentTime() {
  let today = new Date();
  return today.toLocaleTimeString();
}

/**
 * 웹 브라우저 확인(PC OR Mobile)
 * @returns
 */
export function GetIsMobile() {
  let user = navigator.userAgent;
  let isMobile = false;

  if (user.indexOf("iPhone") > -1 || user.indexOf("Android") > -1) {
    isMobile = true;
  }

  return isMobile;
}

export function CustomAlertExit(
  pTitle,
  pButtons,
  pActionConfirm,
  pActionCancle
) {
  CustomAlert(pTitle, pButtons, pActionConfirm, pActionCancle, true);
}

/**
 *
 * @param {Alert text} pText
 * @param {Buttons boolean} pButtons - true: show confirm/cancel, false: show only confirm
 * @param {Listener of Confirm} pActionConfirm
 * @param {Listener of Cancle} pActionCancle
 */
export function CustomAlert(
  pText,
  pButtons,
  pActionConfirm,
  pActionCancle,
  pIsExitAlert
) {
  let alertBody = {
    text: pText,
    theme: document.documentElement.classList.contains("dark") ? "dark" : "light",
    width: "400px",
    background: "rgb(var(--c-surface))",

    // 팝업이 html 높이를 auto 로 바꿔 세로 스크롤바가 생기는 문제 방지
    heightAuto: false,
    scrollbarPadding: false,

    showConfirmButton: pButtons,
    confirmButtonText: "OK",
    confirmButtonColor: "#3085d6",

    showCancelButton: pButtons,
    cancelButtonText: "Cancel",
    cancelButtonColor: "#6c757d",

    customClass: {
      image: "swal-icon-animate",
      htmlContainer: "i18n-multiline",
    },
  };

  if (pIsExitAlert !== undefined && pIsExitAlert === true) {
    alertBody.imageUrl = require("@/assets/images/iconAlert.png");
    alertBody.imageWidth = 58;
    alertBody.imageHeight = 58;
  }

  Swal.fire(alertBody).then((result) => {
    if (result.isConfirmed && pActionConfirm != null) {
      pActionConfirm();
    } else if (result.isDismissed && pActionCancle != null) {
      pActionCancle();
    }
  });
}

/**
 * 텍스트 입력형 Alert
 * @param {Alert text} pText
 * @param {입력창 초기값} pInputValue
 * @param {입력창 placeholder} pPlaceholder
 * @param {확인 시 콜백(입력값 전달)} pActionConfirm
 */
export function CustomAlertInput(
  pText,
  pInputValue,
  pPlaceholder,
  pActionConfirm
) {
  Swal.fire({
    text: pText,
    theme: document.documentElement.classList.contains("dark") ? "dark" : "light",
    width: "400px",
    background: "rgb(var(--c-surface))",

    // 팝업이 html 높이를 auto 로 바꿔 세로 스크롤바가 생기는 문제 방지
    heightAuto: false,
    scrollbarPadding: false,

    input: "text",
    inputValue: pInputValue || "",
    inputPlaceholder: pPlaceholder || "",
    inputAttributes: { maxlength: 100 },

    showConfirmButton: true,
    confirmButtonText: "OK",
    confirmButtonColor: "#3085d6",

    showCancelButton: true,
    cancelButtonText: "Cancel",
    cancelButtonColor: "#6c757d",

    customClass: {
      htmlContainer: "i18n-multiline",
    },
  }).then((result) => {
    if (result.isConfirmed && pActionConfirm != null) {
      pActionConfirm(result.value);
    }
  });
}

/**
 * @param {Alert text} pText
 * @param {Buttons object} pButtons - { val1: "text1", val2: "text2", val3: "text3" }
 * @param {Listener for val1} pActionConfirm
 * @param {Listener for val2} pActionCancle
 * @param {Listener for val3} pActionCancle2
 */
export function CustomAlertMultiButtons(
  pText,
  pButtons,
  pActionConfirm,
  pActionCancle,
  pActionCancle2
) {
  Swal.fire({
    text: pText,
    theme: document.documentElement.classList.contains("dark") ? "dark" : "light",

    // 팝업이 html 높이를 auto 로 바꿔 세로 스크롤바가 생기는 문제 방지
    heightAuto: false,
    scrollbarPadding: false,

    imageUrl: require("@/assets/images/iconAlert.png"),
    imageWidth: 58,
    imageHeight: 58,

    showConfirmButton: true,
    confirmButtonText: pButtons.val3,
    confirmButtonColor: "#3085d6",

    showDenyButton: true,
    denyButtonText: pButtons.val1,
    denyButtonColor: "#dc3545",

    showCancelButton: true,
    cancelButtonText: pButtons.val2,
    cancelButtonColor: "#6c757d",
    customClass: {
      popup: "swal-icon-animate",
      htmlContainer: "i18n-multiline",
    },
  }).then((result) => {
    if (result.isConfirmed) {
      // val3 button clicked
      if (pActionCancle2 != null) pActionCancle2();
    } else if (result.isDenied) {
      // val1 button clicked
      if (pActionConfirm != null) pActionConfirm();
    } else if (result.isDismissed) {
      // val2 button clicked
      if (pActionCancle != null) pActionCancle();
    }
  });
}

// 계속/종료 2버튼 확인 팝업 (center 고정, 밖 클릭·ESC 차단으로 강제 응답).
// pTimeoutMs 를 주면 그 시간 무입력 시 자동 닫힘 → onNo 처리(종료).
export function CustomConfirm(pText, pYesText, pNoText, onYes, onNo, pTimeoutMs) {
  const opts = {
    text: pText,
    theme: document.documentElement.classList.contains("dark") ? "dark" : "light",
    heightAuto: false,
    scrollbarPadding: false,
    position: "center",
    imageUrl: require("@/assets/images/iconAlert.png"),
    imageWidth: 58,
    imageHeight: 58,
    showConfirmButton: true,
    confirmButtonText: pYesText,
    confirmButtonColor: "#3085d6",
    showCancelButton: true,
    cancelButtonText: pNoText,
    cancelButtonColor: "#6c757d",
    allowOutsideClick: false,
    allowEscapeKey: false,
    customClass: { popup: "swal-icon-animate", htmlContainer: "i18n-multiline" },
  };
  if (pTimeoutMs && pTimeoutMs > 0) {
    opts.timer = pTimeoutMs;      // 무입력 자동 종료
    opts.timerProgressBar = true; // 남은 시간 표시
  }
  Swal.fire(opts).then((r) => {
    if (r.isConfirmed) {
      if (onYes != null) onYes();
    } else {
      // 취소(No) 또는 timer 만료(무입력) → 종료 처리
      if (onNo != null) onNo();
    }
  });
}
